import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const WarningMessage = ({ message, linkText = "Edit your profile here", userId }) => {
  return (
    <div
      style={{
        backgroundColor: "#ffeaa7",
        padding: "15px 20px",
        borderRadius: "8px",
        margin: "20px 0",
        textAlign: "center",
        border: "2px solid #fdcb6e",
      }}
    >
      <Icon
        icon="material-symbols:info-outline"
        style={{ marginRight: "8px", fontSize: "20px" }}
      />
      {message}
      <br />
      <Link
        to={`/users/${userId}/edit`}
        style={{
          marginLeft: "5px",
          color: "#0984e3",
          fontWeight: "bold",
          textDecoration: "underline",
        }}
      >
        {linkText}
      </Link>
      <br />
      If you have updated, refresh the page and this message should disappear!
    </div>
  );
};

export default WarningMessage;